module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Recebedor validado!","description":"Agora você pode vender com este recebedor e movimentar o saldo com mais segurança."},"en-US":{"title":"Recipient validated","description":"Now you can make sales with this recipient and change his balance with more security."}}')
  delete Component.options._Ctor
}
